import React, { useState } from 'react'

import PropTypes from 'prop-types'

import './slideshow.css'

const Slideshow = (props) => {
  const [imageSlide, setImageSlide] = useState(1)
  return (
    <div className={`slideshow-container ${props.rootClassName} `}>
      {imageSlide === 1 && (
        <div className="slideshow-thq-slide1-elm">
          <div onClick={() => setImageSlide(5)} className="slide_button">
            <svg viewBox="0 0 1024 1024" className="slideshow-icon10">
              <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
            </svg>
          </div>
          <div
            onClick={() => setImageSlide(2)}
            className="slideshow-thq-rightbtn-elm1 slide_button"
          >
            <svg viewBox="0 0 1024 1024" className="slideshow-icon12">
              <path d="M512 170l342 342-342 342-60-60 238-240h-520v-84h520l-238-240z"></path>
            </svg>
          </div>
          <div className="slideshow-thq-highlight-elm1">
            <span className="slideshow-text10">{props.text}</span>
          </div>
          <div className="slideshow-thq-text-elm1">
            <span className="slideshow-text11">{props.text1}</span>
            <span className="slideshow-text12">{props.text2}</span>
          </div>
          <img
            alt={props.imageAlt3}
            src={props.imageSrc1}
            loading="eager"
            className="slideshow-image1"
          />
        </div>
      )}
      {imageSlide === 2 && (
        <div className="slideshow-thq-slide2-elm">
          <div
            onClick={() => setImageSlide(1)}
            className="slide_button slideshow-thq-leftbtn-elm2"
          >
            <svg viewBox="0 0 1024 1024" className="slideshow-icon14">
              <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
            </svg>
          </div>
          <div
            onClick={() => setImageSlide(3)}
            className="slideshow-thq-rightbtn-elm2 slide_button"
          >
            <svg viewBox="0 0 1024 1024" className="slideshow-icon16">
              <path d="M512 170l342 342-342 342-60-60 238-240h-520v-84h520l-238-240z"></path>
            </svg>
          </div>
          <div className="slideshow-thq-highlight-elm2">
            <span className="slideshow-text13">{props.text4}</span>
          </div>
          <div className="slideshow-thq-text-elm2">
            <span className="slideshow-text14">{props.text12}</span>
            <span className="slideshow-text15">{props.text22}</span>
          </div>
          <img
            alt={props.imageAlt21}
            src={props.imageSrc2}
            loading="eager"
            className="slideshow-image2"
          />
        </div>
      )}
      {imageSlide === 3 && (
        <div className="slideshow-thq-slide3-elm">
          <div
            onClick={() => setImageSlide(2)}
            className="slide_button slideshow-thq-leftbtn-elm3"
          >
            <svg viewBox="0 0 1024 1024" className="slideshow-icon18">
              <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
            </svg>
          </div>
          <div
            onClick={() => setImageSlide(4)}
            className="slideshow-thq-rightbtn-elm3 slide_button"
          >
            <svg viewBox="0 0 1024 1024" className="slideshow-icon20">
              <path d="M512 170l342 342-342 342-60-60 238-240h-520v-84h520l-238-240z"></path>
            </svg>
          </div>
          <div className="slideshow-thq-highlight-elm3">
            <span className="slideshow-text16">{props.text3}</span>
          </div>
          <div className="slideshow-thq-text-elm3">
            <span className="slideshow-text17">{props.text11}</span>
            <span className="slideshow-text18">{props.text21}</span>
          </div>
          <img
            alt={props.imageAlt11}
            src={props.imageSrc12}
            loading="eager"
            className="slideshow-image3"
          />
        </div>
      )}
      {imageSlide === 4 && (
        <div className="slideshow-thq-slide4-elm">
          <div
            onClick={() => setImageSlide(3)}
            className="slide_button slideshow-thq-leftbtn-elm4"
          >
            <svg viewBox="0 0 1024 1024" className="slideshow-icon22">
              <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
            </svg>
          </div>
          <div
            onClick={() => setImageSlide(5)}
            className="slideshow-thq-rightbtn-elm4 slide_button"
          >
            <svg viewBox="0 0 1024 1024" className="slideshow-icon24">
              <path d="M512 170l342 342-342 342-60-60 238-240h-520v-84h520l-238-240z"></path>
            </svg>
          </div>
          <div className="slideshow-thq-highlight-elm4">
            <span className="slideshow-text19">{props.text32}</span>
          </div>
          <div className="slideshow-thq-text-elm4">
            <span className="slideshow-text20">{props.text112}</span>
            <span className="slideshow-text21">{props.text212}</span>
          </div>
          <img
            alt={props.imageAlt121}
            src={props.imageSrc121}
            loading="eager"
            className="slideshow-image4"
          />
        </div>
      )}
      {imageSlide === 5 && (
        <div className="slideshow-thq-slide5-elm">
          <div
            onClick={() => setImageSlide(4)}
            className="slide_button slideshow-thq-leftbtn-elm5"
          >
            <svg viewBox="0 0 1024 1024" className="slideshow-icon26">
              <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
            </svg>
          </div>
          <div
            onClick={() => setImageSlide(1)}
            className="slideshow-thq-rightbtn-elm5 slide_button"
          >
            <svg viewBox="0 0 1024 1024" className="slideshow-icon28">
              <path d="M512 170l342 342-342 342-60-60 238-240h-520v-84h520l-238-240z"></path>
            </svg>
          </div>
          <div className="slideshow-thq-highlight-elm5">
            <span className="slideshow-text22">{props.text31}</span>
          </div>
          <div className="slideshow-thq-text-elm5">
            <span className="slideshow-text23">{props.text111}</span>
            <span className="slideshow-text24">{props.text211}</span>
          </div>
          <img
            alt={props.imageAlt111}
            src={props.imageSrc111}
            loading="eager"
            className="slideshow-image5"
          />
        </div>
      )}
    </div>
  )
}

Slideshow.defaultProps = {
  imageSrc121: '/slideshow/4-1000w.webp',
  text: 'A Land of Wonder',
  rootClassName: '',
  imageSrc12: '/slideshow/3-1000w.webp',
  text2:
    "The picturesque landscapes of Romania will leave you in awe. From the rolling hills of Transylvania to the rugged Carpathian Mountains, Romania is a land of natural beauty that seems to have been painted by an artist's brush",
  text11: 'Where legends are born',
  imageAlt111: 'image',
  imageSrc111: '/slideshow/5-1000w.webp',
  imageAlt3: 'image',
  text3: 'A Land of Castles',
  imageSrc1: '/slideshow/1-1000w.webp',
  text112: 'Where the past meets the present',
  text4: 'A Land of Colour',
  imageSrc2: '/slideshow/2-1000w.webp',
  text22:
    "Romania's seasons are as diverse as the country itself. From the warm golden hues of autumn to the vibrant blooms of spring, each season brings a new story to tell. Experience the colors of Romania and let them leave an everlasting impression on your mind",
  imageAlt121: 'image',
  text32: 'A Land of Traditions',
  text12: 'Where each season tells a story',
  text212:
    "Romania's rich cultural heritage is alive and well, with many traditions still celebrated today. Experience the music, dance, and folklore of Romania and discover a country with deep rooted values",
  text31: 'A Land of Diversity',
  text21:
    'Romania is home to countless stunning castles and fortresses that hold stories and legends of a bygone era. Each castle, from the Gothic masterpiece of Bran Castle to the fairytale-like Peles Castle, transports you to a different time and place and leaves you with a sense of wonder',
  imageAlt11: 'image',
  text211:
    'Romania is a country of diverse regions and people, each with their own unique culture and traditions. From historic cities to beautiful forests and seaside resorts at the Black Sea, Romania is a country that offers endless possibilities for exploration and discovery',
  text1: 'Where every frame is a painting',
  text111: 'Where every corner tells a different tale',
  imageAlt21: 'image',
}

Slideshow.propTypes = {
  imageSrc121: PropTypes.string,
  text: PropTypes.string,
  rootClassName: PropTypes.string,
  imageSrc12: PropTypes.string,
  text2: PropTypes.string,
  text11: PropTypes.string,
  imageAlt111: PropTypes.string,
  imageSrc111: PropTypes.string,
  imageAlt3: PropTypes.string,
  text3: PropTypes.string,
  imageSrc1: PropTypes.string,
  text112: PropTypes.string,
  text4: PropTypes.string,
  imageSrc2: PropTypes.string,
  text22: PropTypes.string,
  imageAlt121: PropTypes.string,
  text32: PropTypes.string,
  text12: PropTypes.string,
  text212: PropTypes.string,
  text31: PropTypes.string,
  text21: PropTypes.string,
  imageAlt11: PropTypes.string,
  text211: PropTypes.string,
  text1: PropTypes.string,
  text111: PropTypes.string,
  imageAlt21: PropTypes.string,
}

export default Slideshow
